<template>
    <div>
        <div class="search-box">
            <p>学年：</p>
            <a-date-picker
                class="input-box"
                mode="year"
                format='YYYY'
                v-model="year" 
                :open='yearShowOne' 
                @openChange="openChangeOne"
                @panelChange="panelChangeOne">
                <a-input  v-model="searchFrom.schoolYear" />
            </a-date-picker>
            <p>教师姓名：</p>
            <a-input class="input-box" v-model="searchFrom.teacherName" allowClear/>
            <!-- <p>职称：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.technicalTitleCode">
                <a-select-option v-for="(item,index) in zcArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select> -->
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
        </div>
        <div class="operation-box">
            <!-- <a-button 
                type="primary"
                icon="plus" 
                class="btn" 
                @click="$router.push('/admin/faculty/allowance/info?type=add')"
                v-if="permissions.indexOf('faculty:assess:add')>-1">
                 新增
            </a-button>
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="selectedRowKeys[0] == null ? selectedCheck() :remove(selectedRowKeys[0])">
                <a-button
                    v-if="permissions.indexOf('faculty:assess:delete')>-1"
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    >
                    删除
                </a-button>
            </a-popconfirm>
            <a-button 
                type="primary"
                icon="edit" 
                class="btn" 
                @click="selectedRowKeys[0] == null ? selectedCheck() : $router.push('/admin/faculty/allowance/info?type=edit&id='+selectedRowKeys[0])"
                v-if="permissions.indexOf('faculty:assess:edit')>-1">
                 编辑
            </a-button> -->
            <a-button
                type="primary"
                icon="file-search" 
                class="btn" 
                @click="selectedRowKeys[0] == null ? selectedCheck() : $router.push('/admin/undergraduate/assess/info?schoolYear='+searchFrom.schoolYear+'&teacherId='+selectedRowKeys[0])"
                >
                 查看详情
            </a-button>
            <a-button
                type="primary"
                icon="backward" 
                class="btn"
                v-if="permissions.indexOf('undergraduate:assess:cancel')>-1" 
                @click="selectedRowKeys[0] == null ? selectedCheck() : cancel(selectedRowKeys[0],searchFrom.schoolYear)"
                >
                 取消确认
            </a-button>
        </div>
        
        <a-table
            rowKey='teacherId'
            :customRow="onClickRow"
            :columns="columns"
            :data-source="data" 
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ y: '600px' }"
            :row-selection="{ type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
        </a-table>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,cancel } from '@/baseAPI/undergraduate/culture/assess'
    import { getSchoolYear,selectedCheck } from '@/baseAPI/util'

    export default {
        name: 'teacher',
        data () {
            return {
                columns:[
        {
            title: '序号',
            align:'center',
            width:50,
            customRender: (text, row, index) => {
                return { children: index+1};
            },
        },
        {
            title: '学年',
            dataIndex: 'schoolYear',
            align:'center',
            width:150
        },
        // {
        //     title: '部门',
        //     dataIndex: 'orgCode',
        //     align:'center',
        //     width:120,
        //     sorter: (a, b) => a.orgCode - b.orgCode,
        //     customRender: (text, row, index) => {
        //         this.xbArr.forEach(elment=>{
        //             if(elment.dataCode == text){
        //                 text = elment.dataName
        //             }
        //         })
        //         return text;
        //     },
        // },
        {
            title: '教师编号',
            dataIndex: 'teacherId',
            align:'center',
            sorter: (a, b) => a.teacherId - b.teacherId,
            width:120
        },
        {
            title: '姓名',
            dataIndex: 'teacherName',
            align:'center',
            width:120
        },
        // {
        //     title: '职称',
        //     dataIndex: 'technicalTitleCode',
        //     align:'center',
        //     sorter: (a, b) => a.technicalTitleCode - b.technicalTitleCode,
        //     width:100,
        //     customRender: (text, row, index) => {
        //         this.zcArr.forEach(elment=>{
        //             if(elment.dataCode == text){
        //                 text = elment.dataName
        //             }
        //         })
        //         return text;
        //     },
        // },
        {
            title: '核定总分',
            dataIndex: 'totalScore',
            align:'center',
            width:120,
            sorter: (a, b) => a.totalScore - b.totalScore,
        },
        {
            title: '确定状态',
            dataIndex: 'confirmStatus',
            align:'center',
            sorter: (a, b) => a.confirmStatus - b.confirmStatus,
            width:120,
            customRender: (text, row, index) => {
                return text == '1' ? '已确认' : '未确认'
            },
        }
    ],
                data:[],
                loading: false,
                pagination:{
                    pageSizeOptions: ['10', '20', '30', '50', '100'],
                    showSizeChanger:true,
                    showTotal:total=>'共'+total+'条数据',
                    pageSize: 10,
                    current: 1,
                    total:0,
                },
                selectedRowKeys: [],
                searchFrom:{
                    size: '',
                    current: '',
                    teacherName:'',
                    schoolYear:'',
                },
                xbArr:[],
                xxArr:[],
                kclbArr:[],
                permissions:[],
                year:'',
                yearShowOne:false,
                departmentTree:[],
                bkdyArr:[],
                bkdyqx:'',
                zcArr:[],
                season:{'3':'C','4':'C','5':'C','6':'D','7':'D','8':'D','9':'A','10':'A','11':'A','12':'B','1':'B','2':'B'}
            }
        },
        watch:{
            '$route':{
                handler(newVal,oldVal){
                    if(newVal.path === '/admin/undergraduate/assess'){
                        this.fetch()
                    }
                },
                deep:true,
                immediate:true
            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.xbArr=res.data.dicts;
            })
            getDicts({dataCode:'CAMPUS',status:true}).then(res=>{
                this.xxArr=res.data.dicts;
            })
            getDicts({dataCode:'KCLB',status:true}).then(res=>{
                this.kclbArr=res.data.dicts;
            })
            getDicts({dataCode:'ZC',status:true}).then(res=>{
                this.zcArr=res.data.dicts;
            })
            getDicts({dataCode:'BKDYSZ',status:true}).then(res=>{
                this.bkdyArr=res.data.dicts;
                console.log(this.bkdyArr[0].simpleName)
                console.log(this.bkdyArr[1].simpleName)

                if(new Date().getTime() >= new Date(this.bkdyArr[0].simpleName).getTime()){
                    let now = new Date().getTime()
                    let startDate = new Date(this.bkdyArr[0].simpleName).getTime()
                    let days = parseInt(now - startDate)/(1000 * 60 * 60 * 24)
                    this.bkdyqx = Math.ceil(parseInt(this.bkdyArr[1].simpleName) - days)
                }
            })
            this.searchFrom.schoolYear=(getSchoolYear() - 1)+'-'+(getSchoolYear())
            this.year=getSchoolYear() - 1 +''
            // this.searchFrom.semester=this.year+this.season[new Date().getMonth()+1]
            // this.searchFrom.semester=getSemester()
            // queryDepartmentTreeList().then(res => {
            //     this.departmentTree = res.data[0].children
            // })
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.departmentTree=res.data.dicts;
            })
            this.fetch()
        },
        methods:{
            cancel(teacherId,schoolYear){
                cancel(teacherId,schoolYear).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'取消确认成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },
            selectedCheck(){
                selectedCheck()
            },
            exportTable(){
                // var obj=this.deepCopy(this.searchFrom);
                // delete obj.size;
                // delete obj.current;
                // obj.idList=this.selectedRowKeys;
                exportTable(this.searchFrom).then(res => {
                    window.open(this.$store.state.axiosUrl+'/api-f/statics/tempFileDirectory/'+res.data)
                })
            },  
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.onSelectChange([record.teacherId])
                        }
                    },

                }  
            },
            handleTableChange(pagination){
                this.selectedRowKeys=[];
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                pager.pageSize = pagination.pageSize;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;
                    this.data.forEach(e=>{
                        e.confirmStatus = (e.confirmStatus == 'Y' ? 1 : 2)
                    })
                    this.loading = false;
                })
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            remove(id){
                del(id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除业绩津贴成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.year=this.getTimeStr(value._d,'yyyy')
                this.searchFrom.schoolYear=this.year+'-'+(this.year-0+1);
                this.searchFrom.semester='';
                this.yearShowOne = false;
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
                console.log(selectedRowKeys)
            }
        }
    }
</script>
<style scoped>
    /* >>> .ant-table-thead > tr > th {
        padding: 5px !important;
    }

    >>> .ant-table-tbody > tr > td {
        padding: 5px !important;
    } */

    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 10px;
    }
    
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 10rem;
    }

    .search-box-1
    {
        margin-bottom: 10px;
    }

    .search-box-1 p
    {
        display: inline-block;
    }
    .search-box-1 .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box-1 .input-box{
        margin-right: 1rem;
        width: 10rem;
    }
    /* .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    } */
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    /* .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }
    .ant-dropdown-link{
        display: inline-block;
        font-size: 0.9rem;
    } */
    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }
</style>
